import React from "react";
import { Chip } from "@mui/material";

export default function ParentBadge({ supplier, organizationName }) {
  return supplier ? <span className="scheduling-parent-source"><Chip label="Parent" size="small" />{organizationName && <small>{organizationName}</small>}</span> : null;
}
